const zh_CN={
    'Welcome to React': '欢迎使用'
}

export default zh_CN